import React from 'react'
import { InertiaLink } from '@inertiajs/inertia-react'
import { Subheader } from "@/Components/Subheader";

export function NumberLinkBlock({
  children,
  className = '',
  title,
  number,
  link,
  href,
}) {

  return (
    <div className="w-full p-5 text-white shadow-md md:w-1/3 md:p-8 bg-primary">
      <div className="flex flex-col">
        <Subheader className="font-light" margin="mt-0">{ title }</Subheader>
        <span className="text-5xl font-extrabold font-roboto">{ number }</span>
      </div>
      {(href && link) && (
      <InertiaLink href={href} className="px-3 py-3 mt-4 text-white border-2 border-white btn-outline hover:bg-primary-dark">
        <span className="text-[18px] font-light">{ link }</span>
      </InertiaLink>
      )}
    </div>
  )
}
